var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"审稿意见","visible":_vm.visible,"width":"700px","dialog-style":{ top: '30px' },"destroyOnClose":true,"footer":null,"maskClosable":false},on:{"cancel":() => (this.visible = false)}},[_c('div',{staticClass:"viewOpinion"},[_c('div',{attrs:{"id":"note"}},[_vm._v(_vm._s(_vm.finalOpinion))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }